import { Component, inject } from '@angular/core';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'well-cell-details-dialog',
  standalone: true,
  imports: [],
  templateUrl: './cell-details-dialog.component.html',
  styleUrl: './cell-details-dialog.component.scss',
})
export class CellDetailsDialogComponent {
  dialogConfig = inject(DynamicDialogConfig);
}
